import { Skeleton } from '@/components/ui/skeleton';

export const UsageSkeleton = () => {
  return (
    <div className="space-y-3">
      <Skeleton className="h-5 w-32" />
      <div className="space-y-1.5">
        <Skeleton className="h-3 w-40" />
        <Skeleton className="h-3 w-40" />
      </div>
      <div className="w-full h-[1px] bg-secondary" />
      <Skeleton className="h-8 w-full" />
      <Skeleton className="h-8 w-full" />
    </div>
  );
};
